import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import CoreServices from "../components/CoreServices";
import WhyChooseUs from "../components/WhyChooseUs";
import SliderTop from '../components/SliderTop'
import OurServices from '../components/OurServices'
import OurMission from '../components/OurMission';
import OurTechnology from '../components/OurTechnology';
import VideoAds from '../components/VideoAds';
import InfoSection from '../components/InfoSection';
import CertificationsSlider from '../components/CertificationSlider';
import Footer from '../components/Footer';


const Home = () => {
   useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);
  return (
    <>
    
    <Navbar/>
    <SliderTop/>
    <Hero/>
    
    {/* <OurServices/> */}
    {/* <OurMission/> */}
    <OurTechnology/>
    <CoreServices/>
    <WhyChooseUs/>
    {/* <InfoSection/> */}
    <CertificationsSlider/>
    <Footer/>
    </>
  )
}

export default Home
